import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Grid,
  Divider,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import ArrowDown from "../../assets/icons/ArrowDown.svg";
import PieChart from "./PieChart";
import DonutChart from "./DonutChart";
import BarChart from "./BarChart";
import moment from "moment";
import CalanderActive from "../../assets/icons/CalanderActive.svg";
import CloseButton from "../../assets/icons/CloseButton.svg";
import { DateEditCalendar } from "../CommonComponent/DateEditCalendar";
import Paper from "@mui/material/Paper";
import { Select, MenuItem, Menu } from "@mui/material";
import FullViewBarChart from "./FullViewBarChart";
import FullViewPieChart from "./FullViewPieChart";
import FullViewDonutChart from "./FullViewDonutChart";
import {
  getCompletedChecklistCountList,
  getDefectreportAllVesselCategoryList,
  getDefectreportAllVesselList,
  getDefectreportByVesselList,
} from "../../redux/actions/dashboardAction";
import { getDefectsList } from "../../redux/actions/defectsAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import noData from "../../assets/images/Group 688.png";
import { useNavigate } from "react-router-dom";
import GenerateDefectId from "../../utils/GenerateDefectId";

const DashboardContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const defectstData = useSelector((state) => state?.defects?.defectstData);

  // const defectstData = useSelector(
  //   (state) => state?.dashboard?.defectstData
  // );
  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const isLoading = useSelector((state) => state?.user?.isLoading);
  const userData = useSelector((state) => state?.user?.userData);

  const [startDate, setStartDate] = useState(
    moment(userData?.createdAt).format("DD MMM, YYYY")
  );

  const [endDate, setEndDate] = useState(moment().format("DD MMM, YYYY"));
  const [anchorEl, setAnchorEl] = useState();
  const [anchorElEnd, setAnchorElEnd] = useState();
  const open = Boolean(anchorEl);
  const openEnd = Boolean(anchorElEnd);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isFullScreenPiechart, setIsFullScreenPiechart] = useState(false);
  const [isFullScreenDonutchart, setIsFullScreenDonutchart] = useState(false);
  const [VesselName, setVesselName] = useState("");
  const handleClick = (event) => {
    setAnchorElEnd(null);
    setAnchorEl(event.currentTarget);
  };

  const handleClickEnd = (event) => {
    setAnchorEl(null);
    setAnchorElEnd(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleCloseEnd = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleSaveDateStart = (value) => {
    const formattedStartDate = moment(value, "YYYY-MM-DD").format(
      "DD MMM, YYYY"
    );
    setStartDate(formattedStartDate);
  };

  const handleSaveDateEnd = (value) => {
    const formattedEndDate = moment(value, "YYYY-MM-DD").format("DD MMM, YYYY");
    setEndDate(formattedEndDate);
  };

  const handleChange = (event) => {
    setVesselName(event.target.value);
  };

  const handleViewCloseChart3 = () => {
    setIsFullScreen(false);
  };

  const handleViewCloseChart1 = () => {
    setIsFullScreenPiechart(false);
  };

  const handleViewCloseChart2 = () => {
    setIsFullScreenDonutchart(false);
  };

  const formatChecklistId = (
    vesselName,
    departmentName,
    checklistType,
    displayId
  ) => {
    const vesselPrefix = vesselName?.slice(0, 3).toUpperCase() || "XXX";
    const departmentPrefix = departmentName?.charAt(0) || "X";
    const checklistTypePrefix = checklistType?.charAt(0) || "X";
    const year = new Date().getFullYear() || "YYYY";
    const formattedDisplayId = String(displayId).padStart(3, "0") || "000";

    return `${vesselPrefix}/${departmentPrefix}/${year}/${checklistTypePrefix}${formattedDisplayId}`;
  };

  useEffect(() => {
    if (moment(endDate).isSameOrAfter(startDate)) {
      dispatch(
        getDefectreportAllVesselCategoryList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
      dispatch(
        getDefectreportAllVesselList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
      dispatch(
        getDefectreportByVesselList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
      dispatch(
        getCompletedChecklistCountList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
    } else {
      toast.error("End date cannot be before start date");
    }
  }, [VesselName, startDate, endDate, userData?.vessel_id]);

  useEffect(() => {
    dispatch(
      getDefectsList({
        vessel_id:
          userData?.vessel_id === null ? VesselName : userData?.vessel_id,
        department_id: "",
        category_defetct: "",
        offset: 0,
        limit: 5,
        defect_report_status: "",
        startDate: moment(userData?.createdAt).format("YYYY-MM-DDTHH:mm:ss"),
        endDate: moment()
          .add(23, "hours") // Add 0 hours
          .add(59, "minutes") // Add 0 minutes
          .add(0, "seconds")
          .format("YYYY-MM-DDTHH:mm:ss"),
      })
    );
  }, [VesselName]);

  const DefectreportbyVesselData = useSelector(
    (state) => state?.dashboard?.defectReportbyVesselData
  );
  const DefectreportallVesselallData = useSelector(
    (state) => state?.dashboard?.defectReportallVesselCategoryData
  );

  const DefectreportallVesselData = useSelector(
    (state) => state?.dashboard?.defectReportallVesselData
  );

  const CompletedChecklistCount = useSelector(
    (state) => state?.dashboard?.completedChecklistCount?.data
  );

  return (
    <>
      {isFullScreenPiechart === true ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              overflow: "auto",
              width: "auto",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "5px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            <Box>
              <Typography
                sx={{
                  ml: 2,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Category of Defect
              </Typography>
            </Box>
            <Box style={{ display: "flex" }}>
              <Box style={{ padding: "3px" }}>
                <Button
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    border: "1px solid #E5F1EB",
                    backgroundColor: "#E5F1EB",
                    padding: "8px 15px 5px 15px",
                    borderRadius: "10px",
                    textTransform: "capitalize",
                    color: "#20724E",
                    ":hover": {
                      backgroundColor: "#E5F1EB",
                    },
                  }}
                  // onClick={() => setIsAddCompanyAdminMasterModel(true)}
                  onClick={() => {
                    navigate("/defects", {});
                  }}
                >
                  View All Defects
                </Button>
              </Box>
              <Box sx={{ mr: 2 }}>
                <IconButton onClick={handleViewCloseChart1}>
                  <img src={CloseButton} width="30" height="30" />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Divider sx={{ width: "auto" }} />
          <Box>
            <FullViewPieChart data={DefectreportallVesselallData} />
          </Box>
        </Paper>
      ) : isFullScreenDonutchart === true ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              overflow: "auto",
              width: "auto",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "5px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            <Box>
              <Typography
                sx={{
                  ml: 2,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Defects View
              </Typography>
            </Box>
            <Box sx={{ mr: 2 }}>
              <IconButton onClick={handleViewCloseChart2}>
                <img src={CloseButton} width="30" height="30" />
              </IconButton>
            </Box>
          </Box>
          <Divider sx={{ width: "auto" }} />
          <Box>
            <FullViewDonutChart data={DefectreportallVesselData} />
          </Box>
        </Paper>
      ) : isFullScreen === true ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              overflow: "auto",
              width: "auto",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "5px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            <Box>
              <Typography
                sx={{
                  ml: 2,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Defects View
              </Typography>
            </Box>
            <Box sx={{ mr: 2 }}>
              <IconButton onClick={handleViewCloseChart3}>
                <img src={CloseButton} width="30" height="30" />
              </IconButton>
            </Box>
          </Box>
          <Divider sx={{ width: "auto" }} />
          <Box>
            <FullViewBarChart data={DefectreportbyVesselData} />
          </Box>
        </Paper>
      ) : (
        <Box>
          <Paper
            sx={{
              overflow: "auto",
              gap: "10px",
              width: "auto",
              marginBottom: "20px",
              padding: "20px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "5px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "3" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                Completed Checklist:
              </Box>
              <Box
                onClick={() => {
                  navigate("/checklist", {
                    state: {
                      select: "Daily",
                    },
                  });
                }}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#20724E",
                  fontWeight: "bold",
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: 1,
                  height: "37px",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Daily
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  :
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  {CompletedChecklistCount?.Daily}
                </Typography>
              </Box>
              <Box
                onClick={() => {
                  navigate("/checklist", {
                    state: {
                      select: "Weekly",
                    },
                  });
                }}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  color: "#20724E",
                  marginLeft: "10px",
                  display: "flex",
                  cursor: "pointer",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                  height: "37px",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Weekly
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  :
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  {CompletedChecklistCount?.Weekly}
                </Typography>
              </Box>
              <Box
                onClick={() => {
                  navigate("/checklist", {
                    state: {
                      select: "Monthly",
                    },
                  });
                }}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  color: "#20724E",
                  cursor: "pointer",
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                  height: "37px",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Monthly
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  :
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  {CompletedChecklistCount?.Monthly}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex" }}>
              {userData?.role?.name === "VESSEL_ADMIN" ||
              userData?.vessel_id !== null ? (
                ""
              ) : (
                <Select
                  value={VesselName}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "8rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="">
                    <Typography sx={{ fontWeight: "bold" }}>
                      All Vessel
                    </Typography>
                  </MenuItem>

                  {vesselMasterData
                    ?.filter((row) => row.active !== false)
                    .map((row) => (
                      <MenuItem value={row?.id}>{row?.name}</MenuItem>
                    ))}
                </Select>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  mr: 2,
                }}
              >
                <Box
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(event) => handleClick(event)}
                  sx={{
                    background: "#E5F1EB",
                    borderRadius: "8px",
                    width: "9rem",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                >
                  <Typography sx={{ color: "#20724E", fontSize: "14px" }}>
                    {startDate ||
                      moment().startOf("year").format("MMM DD, YYYY")}
                  </Typography>
                  <img src={CalanderActive} width="20" height="20" />
                </Box>
                <Typography
                  sx={{ pr: 1, pl: 1, color: "#000000", fontWeight: "600" }}
                >
                  To
                </Typography>
                <Box
                  aria-controls={openEnd ? "basic-menu-end" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openEnd ? "true" : undefined}
                  onClick={(event) => handleClickEnd(event)}
                  sx={{
                    background: "#E5F1EB",
                    borderRadius: "8px",
                    width: "9rem",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{ color: "#20724E", fontSize: "14px" }}
                    aria-haspopup="true"
                  >
                    {endDate || moment().endOf("year").format("MMM DD, YYYY")}
                  </Typography>
                  <img src={CalanderActive} width="20" height="20" />
                </Box>
                {open && (
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                  >
                    <DateEditCalendar
                      handleCloseCalendar={handleClose}
                      saveTheDate={handleSaveDateStart}
                      date={startDate}
                    />
                  </Menu>
                )}
                {openEnd && (
                  <Menu
                    id="basic-menu-end"
                    anchorEl={anchorElEnd}
                    open={openEnd}
                    onClose={handleCloseEnd}
                  >
                    <DateEditCalendar
                      handleCloseCalendar={handleCloseEnd}
                      saveTheDate={handleSaveDateEnd}
                    />
                  </Menu>
                )}
              </Box>
            </Box>
          </Paper>
          {isLoading ? (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // height: "100%",
              }}
            >
              <CircularProgress color="success" />
            </Box>
          ) : (
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <PieChart
                    setIsFullScreenPiechart={setIsFullScreenPiechart}
                    data={DefectreportallVesselallData}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <DonutChart
                    setIsFullScreenDonutchart={setIsFullScreenDonutchart}
                    data={DefectreportallVesselData}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <BarChart
                    setIsFullScreen={setIsFullScreen}
                    data={DefectreportbyVesselData}
                  />
                </Grid>
              </Grid>

              <Paper
                sx={{
                  width: "auto",
                  height: "auto",
                  overflow: "auto",
                  borderRadius: "10px",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "20px",
                    overflow: "auto",
                    width: "auto",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      height: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#20724E",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#E5F1EB",
                    },
                  }}
                >
                  <Box sx={{ width: "auto" }}>
                    <Typography
                      // onClick={() => {
                      //   navigate("/defects/editdefectdetails");
                      // }}
                      sx={{
                        ml: 2,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#212121",
                      }}
                    >
                      Latest Defects
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 2,
                        color: "#B5B5C3",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Recent Top 5 defects will appear here.
                    </Typography>
                  </Box>
                  <Box sx={{ padding: " 0 28px " }}>
                    <Button
                      // disabled={Props.data && Props.data.total !== 0 ? false : true}
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        border: "1px solid #E5F1EB",
                        backgroundColor: "#E5F1EB",
                        padding: "8px 15px 5px 15px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        color: "#20724E",
                        ":hover": {
                          backgroundColor: "#E5F1EB",
                        },
                      }}
                      // onClick={() => setIsAddCompanyAdminMasterModel(true)}
                      onClick={() => {
                        navigate("/defects", {
                          state: { DefectsOpen: null },
                        });
                      }}
                    >
                      view All
                    </Button>
                  </Box>
                </Box>
                <Divider />

                <Box sx={{ margin: "10px 25px 15px 20px" }}>
                  <TableContainer
                    sx={{
                      maxHeight: "350px",
                      "&::-webkit-scrollbar": {
                        width: "5px",
                        height: "3px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#20724E",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#E5F1EB",
                      },
                    }}
                  >
                    {defectstData?.length <= 0 ? (
                      <Grid sx={{ paddingTop: "20px" }}>
                        <Grid
                          item
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Box>
                            <Box
                              component="img"
                              sx={{
                                height: "15rem",
                                width: "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              alt=""
                              src={noData}
                            />
                          </Box>
                          <Box
                            fontWeight="600"
                            sx={{ padding: "20px", fontWeight: "600" }}
                          >
                            <Typography
                              sx={{ fontWeight: "600", fontSize: "18px" }}
                            >
                              No Data Found
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    ) : (
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Defect ID
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Vessel Name
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Checklist ID
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Category Of Defect
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Department
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Created Date & Time
                            </TableCell>

                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Status
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#B5B5C3",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              Closure Date
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {defectstData?.map((row) => (
                            <TableRow
                              onClick={() => {
                                navigate("/defects", {
                                  state: {
                                    select: "Daily",
                                  },
                                });
                              }}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                "&:hover": {
                                  backgroundColor: "#E5F1EB",
                                  cursor: "pointer",
                                },
                              }}
                            >
                              <TableCell
                                sx={{
                                  color: "#464E5F",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {GenerateDefectId(
                                  row?.vessel?.name,
                                  row?.display_id
                                )}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#464E5F", fontWeight: "600" }}
                              >
                                {row?.vessel?.name}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#464E5F", fontWeight: "600" }}
                              >
                                {formatChecklistId(
                                  row?.vessel?.name,
                                  row?.checklist?.department?.name,
                                  row?.checklist?.checklist_type?.name,
                                  row?.check_list_type_info?.display_id
                                )}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#464E5F", fontWeight: "600" }}
                              >
                                {row.category_defetct}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#464E5F", fontWeight: "600" }}
                              >
                                {row?.checklist?.department?.name}
                              </TableCell>
                              <TableCell
                                sx={{ color: "#464E5F", fontWeight: "600" }}
                              >
                                {moment(row?.createdAt)
                                  .local()
                                  .format("D MMMM, YYYY | hh:mm A")}
                              </TableCell>
                              {/* <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                      {moment(row?.updatedAt)
                        .utc()
                        .format("D MMMM, YYYY | hh:mm A")}
                    </TableCell> */}
                              <TableCell
                                align="center"
                                sx={{ color: "#464E5F" }}
                              >
                                <Box
                                  sx={{
                                    background:
                                      row.defect_report_status === "open"
                                        ? "#FFE2E5"
                                        : "#E5F1EB",
                                    color:
                                      row.defect_report_status === "open"
                                        ? "#FF4646"
                                        : "#20704D",
                                    border:
                                      row.defect_report_status === "open"
                                        ? "1px solid #FFE2E5"
                                        : "1px solid #E5F1EB",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    width: "6rem",
                                    padding: "5px",
                                    borderRadius: "6px",
                                    font: "Poppins",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row.defect_report_status === "open"
                                    ? "Open"
                                    : "Closed"}
                                </Box>
                              </TableCell>
                              <TableCell sx={{ color: "#464E5F" }}>
                                {row?.closure_date === null
                                  ? "-"
                                  : moment(row?.closure_date).local().format(
                                      "D MMMM, YYYY | hh:mm A"
                                    )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </Box>
              </Paper>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default DashboardContent;
